/**
 * Created by Shikha 07/1/2020.
 */
import {TimelineLite,Timeline,TweenLite} from "gsap";
import {IImortalFruitsParsedServerData} from "../server/data/IImortalFruitsParsedServerData";
import {ImmortalFruitsParsedGameData} from "../server/data/ImmortalFruitsParsedGameData";
import {GameRoundPresentation} from "@nolimitcity/slot-game/bin/timelinegameround/core/gameround/GameRoundPresentation";
import {ImmortalFruitsGameMode} from "../ImmortalFruitsGameMode";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {ReelEvent} from "@nolimitcity/slot-game/bin/core/reel/event/ReelEvent";

export class bonusWheelEvents {
    public static readonly STOP_WHEEL: string = "bonusWheelEvents_STOP_WHEEL";
    public static readonly END_ANIMATION: string = "bonusWheelEvents_END_ANIMATION";
    public static readonly ABORT_WP: string = "bonusWheelEvents_ABORT_WP";
    public static readonly NOTIFY_FINISH: string = "bonusWheelEvents_NOTIFY_FINISH";
    public static readonly ABORT_SPINNING: string = "bonusWheelEvents_ABORT_SPINNING";
    public static readonly ABORT_STOPPABLE: string = "bonusWheelEvents_ABORT_INITIALSPINNING";
    public static readonly SHOW_WHEEL_ANIMATION: string = "bonusWheelEvents_SHOW_WHEEL_ANIMATION";
    public static readonly HIDE_WHEELS: string = "bonusWheelEvents_HIDE_WHEELS";
    public static readonly NOTIFY_WP_FINISH: string = "bonusWheelEvents_NOTIFY_WP_FINISH";
    public static readonly START_BIGWIN: string = "bonusWheelEvents_START_BIGWIN";
    public static readonly STOP_BIGWIN: string = "bonusWheelEvents_STOP_BIGWIN";
    public static readonly HIGHLIGHT_ONABORT: string = "bonusWheelEvents_HIGHLIGHT_ONABORT";
    public static readonly ABORT_ANIMATIONS: string = "bonusWheelEvents_ABORT_ANIMATIONS";
    public static readonly BEGIN_ANIMATING: string = "bonusWheelEvents_BEGIN_ANIMATING";
    public static readonly BEGIN_SPIN: string = "bonusWheelEvents_BEGIN_SPIN";
    public static readonly SHOW_JACKPOTWON: string = "BetLineEvents_SHOW_JACKPOTWON";
    public static readonly HIDE_JACKPOTWON: string = "BetLineEvents_HIDE_JACKPOTWON";
}
export class bonusWheelController implements GameRoundPresentation {
    private _tl: TimelineLite;
    stagger?: number;
    abortStagger?: number;
    private _scatterPositions:number[];
    private nextMode: string;
    private _isAborted: boolean = false;

    constructor(stagger?: number, abortStagger?: number) {
        this.stagger = stagger;
        this.abortStagger = abortStagger;

    }

    public getAnimation(data: ImmortalFruitsParsedGameData): Timeline | null {

        if(data.nextMode===ImmortalFruitsGameMode.BONUS_WHEEL || data.mode ===ImmortalFruitsGameMode.BONUS_WHEEL) {
            /*299*/
            EventHandler.dispatchEvent(new GameEvent(ReelEvent.ALL_REELS_SPIN_STARTED));

            this._tl = new TimelineLite({onComplete:()=>{
                    //console.log("endAnimation")
                }});
            this._tl.add(()=>{
                EventHandler.dispatchEvent(new GameEvent(bonusWheelEvents.BEGIN_SPIN))
                //starting spin ; while response is awaited
            },2);
            this._tl.add(()=>{
                //to stop if response is already received
            },2.2);
            this._tl.add(()=>{
                if(this._scatterPositions){
                    EventHandler.dispatchEvent(new GameEvent(bonusWheelEvents.BEGIN_ANIMATING))
                    //initial animations before spinning
                }

            },0);
            return this._tl;
        }
        return null;
    }

    public prepare(data: IImortalFruitsParsedServerData): void {
        this.nextMode = data.nextMode;
        this._isAborted = false;
        this._scatterPositions = data.scatterPositions!;
    }
}
